import { useLocation } from "react-router-dom";

import ChartSettings from "../../Blocks/Modals/SettingsModal/ChartSettings/ChartSettings";
import SettingsModal from "../../Blocks/Modals/SettingsModal/SettingsModal";
import {
  ChartSettingSectionNames,
  ChartSettingsSectionRoutes,
  enumChartSettings
} from "../../../providers/NavigationProvider";
import { getCurrentSectionData, getRouteToNextTab } from "../_utils";
import { useAppNavigate } from "@/hooks/useAppNavigate";
import * as StateLib from "@/Utils/StateLib";
import Header from "@/appComponents/Navigation/Header/Header";
import cx from "classnames";
import { appstr } from "@coreapp/utils/appstr";
import { Globals } from "@coreapp/CoreApp/Globals";
import { kAdminUser } from "@coreapp/constants";
import { CapitalizeFirstWord } from "@/Utils/DataLib";

const ChartSettingsPage = () => {
  const nav = useAppNavigate();
  let wsMgr = StateLib.GetWSMgr();
  const location = useLocation();
  const [, , , urlChartID, sectionRoute] = location.pathname.split("/");

  const chartID =
    urlChartID ||
    StateLib.GetDoc()?.GetChartID() ||
    wsMgr?.GetOrgInfo()?.GetMasterChartList()?.[0]?.["ID"];
  const { sectionKey, tabIndex } = getCurrentSectionData(
    sectionRoute,
    "DataSource",
    ChartSettingsSectionRoutes,
    enumChartSettings
  );

  const handleChangeCurrentTab = nextTab => {
    const route = getRouteToNextTab(nextTab, enumChartSettings, ChartSettingsSectionRoutes);
    nav.navigateSettings("chart", chartID, route, { replace: true });
    wsMgr.UpdateDocTitle();
  };

  if (!(Globals._accountInfo.GetUserRole() === kAdminUser)) {
    return null;
  }

  return (
    <>
      <div className={cx("appHeader--modal")}>
        <Header customToolbarClass={"oc-settings-toolbar"} />
        <SettingsModal
          title={appstr("Chart Settings")}
          subtitle={CapitalizeFirstWord(appstr(ChartSettingSectionNames[sectionKey]))}
        >
          {({ onCloseModal }) => (
            <ChartSettings
              /* Prevent empty string from being passed if not specified in URL */
              chartID={chartID || undefined}
              sectionKey={sectionKey}
              currentTab={tabIndex}
              setCurrentTab={handleChangeCurrentTab}
              onCloseModal={onCloseModal}
            />
          )}
        </SettingsModal>
      </div>
    </>
  );
};

export default ChartSettingsPage;
